import { render } from "./ComponentNoData.vue?vue&type=template&id=dbba392c"
import script from "./ComponentNoData.vue?vue&type=script&lang=js"
export * from "./ComponentNoData.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__